import type { PreApprovalData, PreApprovalMetadata } from '@/types/pre-approval';

function sanitizeMetadataForClone(metadata?: PreApprovalMetadata): PreApprovalMetadata {
  if (!metadata) {
    return {};
  }

  const { recipients: _recipients, activities: _activities, ...rest } = metadata;
  return { ...rest };
}

export function createPreApprovalCloneDraft(source: PreApprovalData, now = new Date()): PreApprovalData {
  const timestamp = now.toISOString();

  return {
    ...source,
    id: Date.now().toString(36) + Math.random().toString(36).substr(2),
    status: 'draft',
    createdAt: timestamp,
    updatedAt: timestamp,
    sentAt: undefined,
    viewedAt: undefined,
    acceptedAt: undefined,
    expiredAt: undefined,
    expiredReason: undefined,
    trackingId: undefined,
    viewCount: 0,
    accessLink: undefined,
    metadata: sanitizeMetadataForClone(source.metadata),
    modifications: [],
    comments: [],
    activities: [],
    loanOfficerSignatureDate: undefined,
    loanOfficerSignatureDataUrl: undefined,
    loanOfficerSignatureMethod: undefined,
    loanOfficerSignatureFont: undefined,
    loanOfficerSignatureIpAddress: undefined,
    loanOfficerSignatureUserAgent: undefined,
    loanOfficerSignatureAuditLog: undefined,
    hasLoanOfficerSignature: false,
    signatureSendCount: undefined,
    lastSentWithSignatureAt: undefined,
    signatureRecipientHistory: undefined,
    signedPdfUrl: undefined,
    signedPdfGeneratedAt: undefined
  };
}
